<script>
  import { fade } from "svelte/transition";
	import Load from "../components/Load.svelte" 
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = []; 
  let itemsDisplay = false;
  let items = [];

  let uid = Math.random().toString(36).substring(2);
  axios
    .get(settings.url + "/sipade/akun", {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      items = response.data;
      itemsDisplay = true;
    })
    .catch(function (error) {
      if (error.response.status == 401) {
        localStorage.removeItem("t");
        redirect("/login");
      } else {
        if (error.response.data.message) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        }
      }
    });
</script>
<svelte:head>
<title>Detail Profil - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  message={navigation['message']}
  title="Profil Anda" />
<main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
  <div class="pt-2 mx-auto my-5 lg:mt-10 lg:my-0">
    {#if itemsDisplay}
      <div class="max-w-2xl mx-auto rounded-lg">
        <Title
          subtitle="Untuk melakukan perubahan silahkan kunjungi unit pelayanan
          terdekat"
          title="Profil Anda"
          tipe="2" />
        <div class="w-full mx-auto my-5 lg:my-0">
          <div class="w-full mx-auto mb-2">
            <div
              class="flex flex-wrap justify-between p-10 bg-white rounded-md shadow-md">
              <table width="100%" border="0">
                <tbody>
                  <tr>
                    <td colspan="5">
                      <h4>
                        <b>
                          NIK :
                          <span id="nikQRcode"> {items.pen.nik} <span /> </span>
                        </b>
                      </h4>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      <h4>
                        <b>
                          Nomor KK :
                          <span> {items.pen.nokk} <span /> </span>
                        </b>
                      </h4>
                    </td>
                  </tr>
                  <tr>
                    <td class="labelform" colspan="2"><b>Nama</b></td>
                    <td class="labelform" width="2%">:</td>
                    <td colspan="5">{items.pen.nm}</td>
                  </tr>
                  <tr>
                    <td class="labelform" colspan="2">
                      <b>Tempat/Tgl Lahir</b>
                    </td>
                    <td class="labelform">:</td>
                    <td colspan="3">{items.pen.t}, {items.pen.tl}</td>
                  </tr>
                  <tr>
                    <td colspan="2"><b>Jenis Kelamin</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.jk}</td>
                  </tr>
                  <tr>
                    <td colspan="2"><b>Alamat</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.almt}</td>
                  </tr>
                  <tr>
                    <td width="17%" />
                    <td width="17%"><b>RT/RW</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.rt}/{items.pen.rw}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td><b>Kel/Desa</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.ds}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td><b>Kecamatan</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.kec}</td>
                  </tr>
                  <tr>
                    <td colspan="2"><b>Agama</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.agm}</td>
                  </tr>
                  <tr>
                    <td colspan="2"><b>Status Perkawinan</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.kwn}</td>
                  </tr>
                  <tr>
                    <td colspan="2"><b>Pekerjaan</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.krj}</td>
                  </tr>
                  <tr>
                    <td colspan="2"><b>Kewarganegaraan</b></td>
                    <td>:</td>
                    <td colspan="2">{items.pen.wn}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    {:else}
    <Load />
    {/if}
  </div>
</main>
